require('./bootstrap');
require('./livewire_events');

window.Swal = require('sweetalert2');


